import {
  Card,
  CardContent,  
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core";
import * as React from "react";
import { useEffect, useState } from "react";
import { QueryFilter } from "src/component/shared/filter/QueryFilter";
import Rest from "src/services/Rest";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import SubTableShareMonthlyEvolution from "./SubTableShareMonthlyEvolution";
import './ShareMonthlyEvolution.scss'
import ItemValue from "./ItemValue";
import DialogShareMonthlyEvolution from "./DialogExportMonthlyEvolution";
interface IShareMonthlyEvolutionProps {
  filter: any;
  loading: any;
  client: any;
}

export default function ShareMonthlyEvolution(
  props: IShareMonthlyEvolutionProps
) {
  const [itens, setItens] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [load, setLoad] = useState<boolean>(false);
  const [pagination, setPagination] = useState({ size: 10, page: 0, total: 0 });
  const [rowsOpen, setRowOpen] = useState<number>(0)

  const columns = [
    { nome: 'action',
      render: (item: any) => 
          <IconButton
            aria-label="expand row"
            onClick={() => handleDetailOpen(item)}
          >
            {rowsOpen !== item.grupoeconomico? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </IconButton>      
    },  
    {render: (item: any) => <div style={{minWidth: '210px', textAlign: 'center'}}>{item.grupo}</div>},    
    {render: (item: any) => <ItemValue  value={item.mes_atual} share={item.mes_atual_share} shareAnterior={item.mes_anterior_1_share}/> }, 
    {render: (item: any) => <ItemValue  value={item.mes_anterior_1} share={item.mes_anterior_1_share} shareAnterior={item.mes_anterior_2_share} /> },    
    {render: (item: any) => <ItemValue  value={item.mes_anterior_2} share={item.mes_anterior_2_share} shareAnterior={item.mes_anterior_3_share}/> },
    {render: (item: any) => <ItemValue  value={item.mes_anterior_3} share={item.mes_anterior_3_share} shareAnterior={item.mes_anterior_4_share}/> },    
    {render: (item: any) => <ItemValue  value={item.mes_anterior_4} share={item.mes_anterior_4_share} shareAnterior={item.mes_anterior_5_share}/> } ,
    {render: (item: any) => <ItemValue  value={item.mes_anterior_5} share={item.mes_anterior_5_share} shareAnterior={item.mes_anterior_6_share}/> },    
    {render: (item: any) => <ItemValue  value={item.mes_anterior_6} share={item.mes_anterior_6_share} shareAnterior={item.mes_anterior_7_share}/> },
    {render: (item: any) => <ItemValue  value={item.mes_anterior_7} share={item.mes_anterior_7_share} shareAnterior={item.mes_anterior_8_share}/> },    
    {render: (item: any) => <ItemValue  value={item.mes_anterior_8} share={item.mes_anterior_8_share} shareAnterior={item.mes_anterior_9_share}/> },
    {render: (item: any) => <ItemValue  value={item.mes_anterior_9} share={item.mes_anterior_9_share} shareAnterior={item.mes_anterior_10_share}/> },    
    {render: (item: any) => <ItemValue  value={item.mes_anterior_10} share={item.mes_anterior_10_share} shareAnterior={item.mes_anterior_11_share}/> },
    {render: (item: any) => <ItemValue  value={item.mes_anterior_11} share={item.mes_anterior_11_share} />}   
  ];

  const search = (paramsPage: any) => {   
    setLoad(true);
    const api = getFilter(true)
    let endPoint = `share-month-evolution?page=${paramsPage.page}&size=${paramsPage.size}`;

    if(api && api !== '') {
      endPoint += api
    }   
    
    
    Rest.GET(endPoint, null)
      .then((response) => response.json())
      .then((result: any) => {
        if (result != null && result !== undefined) {        
          setItens(result.dados);
          setHeaders(result.headers);
          setPagination({
            page: paramsPage.page,
            size: paramsPage.size,
            total: result.total,
          });
        }
        setLoad(false);
      });
  };

  const handleChangePage = (ev: any, pageParam: number) => {
    const params = {
      page: pageParam,
      size: pagination.size,
      total: pagination.total,
    };  
    search(params);
  };

  useEffect(() => {
    if (!props.loading) {
      search(pagination);     
    }
  }, [props.loading]);

  const getKey = () => {
    return Math.random() * 12;
  };

  const handleDetailOpen = (row: any) => {
     setRowOpen(row.grupoeconomico === rowsOpen ? 0 : row.grupoeconomico)
  };

  const getCell = (header: any) => {
    return <TableCell align="center" key={getKey()} style={{textAlign: 'center', borderLeft: '1px solid #e0e0e0'}} ><div style={{minWidth:'150px'}}>{header.mes}</div></TableCell>;
  };

  const getCellRow = (row: any, item: any) => {    
    return <TableCell align="center" style={{textAlign: 'center', borderLeft: '1px solid #e0e0e0'}} key={getKey()} >{item.render(row)}</TableCell>
  }

  const getFilter = (pag: boolean) => {
    const filtros = QueryFilter.getFilterPublisher(props.client, props.filter, ["bookstores",]);
    let endPoint = '';

    if (filtros && filtros.customFilter) {
      if (filtros.customFilter.publishers && filtros.customFilter.publishers.length > 0) {
        filtros.customFilter.publishers.forEach((v: any, index: number) => {
          if (index === 0 && !pag) {
            endPoint += `?book_store=${v}`;
          } else {
            endPoint += `&book_store=${v}`;
          }
        })
      }

      if (filtros.customFilter.bisac && filtros.customFilter.bisac.length > 0) {
        filtros.customFilter.bisac.forEach((v: any, index: number) => {
          if (index === 0 && filtros.customFilter.publishers < 1 && !pag) {
            endPoint += `?bisac=${v}`;
          } else {
            endPoint += `&bisac=${v}`;
          }
        });
      }
    }
    return endPoint;
  }

  return (
    <Grid container={true} spacing={16}>
      <Grid item={true} xs={12} md={12}>
        {load ? (
          <LinearProgress />
        ) : (
          <Paper>
            <Card>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px'}}>
                <Typography>
                  Informações referentes aos últimos 12 Mêses
                </Typography> 
               <DialogShareMonthlyEvolution getFilter={getFilter} />
              </div>
              <CardContent>
                <div className="container-table">
                <Table>
                  <TableHead>
                    <TableRow  style={{ border: '1px solid #e0e0e0'}}>
                      <TableCell style={{borderLeft: '1px solid #e0e0e0'}}/>
                      <TableCell style={{textAlign: 'center', borderLeft: '1px solid #e0e0e0'}}> <div style={{minWidth: '210px'}}>Grupo</div> </TableCell>
                      {headers.map((v) => getCell(v))}
                    </TableRow>
                  </TableHead>
                  {itens && itens.length > 0 && (
                    <TableBody>                      
                      {itens.map((row: any, index: number) => (
                        <>
                        <TableRow key={getKey()} >                          
                         {columns.map((v) => (
                                 getCellRow(row, v)
                           ))}
                        </TableRow>
                        { rowsOpen === row.grupoeconomico && (
                          <SubTableShareMonthlyEvolution                          
                             rowsOpen={rowsOpen}
                             grupo={row.grupoeconomico} 
                             getFilter={getFilter}
                          />
                         )
                        }
                        </>
                      ))}
                    </TableBody>
                  )}
                </Table>   
                </div>             
                 <TablePagination
                    component="div"
                    page={pagination.page}
                    count={pagination.total}
                    rowsPerPage={pagination.size}
                    rowsPerPageOptions={[]}
                    backIconButtonProps={{
                      "aria-label": "Previous Page",
                    }}
                    nextIconButtonProps={{
                      "aria-label": "Next Page",
                    }}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={undefined}
                  />
              </CardContent>
            </Card>
          </Paper>
        )}
      </Grid>
    </Grid>
  );
}





// WEBPACK FOOTER //
// ./src/component/publisher/sale/share-mothly-evolution/ShareMonthlyEvolution.tsx